import React, { useMemo } from 'react';
import { withLoading, useAppContext, createDateObject } from '@front-activerse/common-components';
import Timeline from '../../../Timeline/index.jsx';
import TimelinePlaceholder from '../../../Timeline/TimelinePlaceholder.jsx';
import { Link } from 'react-router-dom';

interface TrackerTimelineProps {
  date: string;
}

const TrackerTimeline: React.FC<TrackerTimelineProps> = ({ date }) => {
  const {
    svgInline: { LeftArrow, RightArrow },
  } = useAppContext();

  // Memoizowane generowanie tablicy dat: 30 dni wstecz, dzisiaj, 30 dni naprzód
  const dates = useMemo(() => {
    const datesList = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 30 dni wstecz
    for (let i = 30; i >= 1; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      datesList.push(date);
    }

    // Dzisiaj
    datesList.push(new Date(today));

    // 30 dni naprzód
    for (let i = 1; i <= 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      datesList.push(date);
    }

    return datesList;
  }, []);

  return (
    <div className="timeline-container">
      <Timeline
        activeDate={createDateObject(date)}
        dates={dates}
        leftArrow={<LeftArrow />}
        rightArrow={<RightArrow />}
      >
        {({
          active,
          isoDate,
          formattedDate,
          linkClassName,
        }: {
          isoDate: string;
          active: boolean;
          formattedDate: React.ReactNode;
          linkClassName: string;
        }) => (
          <Link
            {...(active ? { 'aria-current': 'page' } : {})}
            to={`/tracker/${isoDate}`}
            replace={true}
            className={`${linkClassName}`}
          >
            {formattedDate}
          </Link>
        )}
      </Timeline>
    </div>
  );
};

const Placeholder = () => {
  const {
    svgInline: { LeftArrow, RightArrow },
  } = useAppContext();

  return <TimelinePlaceholder leftArrow={<LeftArrow />} rightArrow={<RightArrow />} />;
};

export default withLoading(TrackerTimeline, Placeholder);
